import "./Modal.css";

import CampaignImage from "./campaign.png";

import { useState, useEffect } from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

const Modal = () => {
    const [showModal, setShowModal] = useState(true);

    const toggleModal = () => {
        setShowModal(!showModal);
    }

    // event listener to close modal when clicked outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (event.target.className === "campaign-modal") {
                setShowModal(false);
            }
        }

        window.addEventListener("click", handleClickOutside);
        return () => {
            window.removeEventListener("click", handleClickOutside);
        };
    }, []);

    return (
        <>
            {showModal &&
                <div id="campaign-modal" className="campaign-modal">
                    <div className="campaign-modal-content">
                        <div className="campaign-modal-header">
                            <h2>River City Cabinets Sale</h2>
                            <span className="campaign-modal-close" onClick={toggleModal}>&times;</span>
                        </div>
                        <div className="campaign-modal-body">
                            <img src={CampaignImage} alt="cabinet discount on projects over $5,000 get a 10% discount and for projects over $10,000 get a 15% discount plus win a free sink!"></img>
                        </div>
                        <div className="campaign-modal-footer">
                            <a href="https://www.facebook.com/rcc208" target="_blank" rel="noreferrer"><button className="primary-button facebook"><i><FontAwesomeIcon icon={icon({name: 'facebook', style: 'brands'})} className='icon' /></i>Redeem on Facebook</button></a>
                            <a href="https://instagram.com/rivercitycabinets/" target="_blank" rel="noreferrer"><button className="primary-button instagram"><i><FontAwesomeIcon icon={icon({name: 'instagram', style: 'brands'})} className='icon' /></i>Redeem on Instagram</button></a>
                            <h3>Contact us for any question</h3>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Modal;